<template>
    <div class="container">
        <div class="header">
            <div class="store-icon">
                <img :src="storeIcon" />
            </div>
            <span class="store-name">{{ store?.storeName }}</span>
        </div>
        <div class="form-section">
            <div class="amount-input-wrapper" @click="changeKeyboardFun">
                <div class="amount-label">金额(¥)</div>
                <div class="amount-value">{{ displayAmount }}</div>
            </div>
            <van-field id="custName" required :adjust-position="false" input-align="right" v-model="formData.custName"
                label="姓名" placeholder="请输入姓名" />
            <van-field id="mobile" required :adjust-position="false" input-align="right" v-model="formData.mobile"
                type="tel" label="手机" placeholder="请输入手机号" />
            <van-field id="remark" :adjust-position="false" input-align="right" v-model="formData.remark"
                type="textarea" label="备注" placeholder="请输入备注" />
        </div>

        <div class="keyboard-wrapper" :class="{ 'hidden': !showKeyboard }">
            <div class="keyboard-grid">
                <div class="key" @click="inputKey('1')">1</div>
                <div class="key" @click="inputKey('2')">2</div>
                <div class="key" @click="inputKey('3')">3</div>
                <div class="key delete-key" @click="deleteKey">
                    <svg viewBox="0 0 24 24" fill="#666" width="28" height="28">
                        <path
                            d="M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z" />
                    </svg>
                </div>
                <div class="key" @click="inputKey('4')">4</div>
                <div class="key" @click="inputKey('5')">5</div>
                <div class="key" @click="inputKey('6')">6</div>
                <div class="key pay-btn" @click="onSubmit">确认支付</div>
                <div class="key" @click="inputKey('7')">7</div>
                <div class="key" @click="inputKey('8')">8</div>
                <div class="key" @click="inputKey('9')">9</div>
                <div class="key zero-key" @click="inputKey('0')">0</div>
                <div class="key" @click="inputKey('.')">.</div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCashierProducts, cashierPay } from "@/api/gjApi.js";
import storeIcon from "@/assets/gj/store.png";
export default {
    name: "fastPayment",
    data() {
        return {
            storeIcon,
            amount: '',
            store: {},
            formData: {
                custName: '',
                mobile: '',
                payWay: '',
                storeId: '',
                amount: '',
            },
            showKeyboard: true,
        };
    },
    computed: {
        displayAmount() {
            if (!this.amount) return '0.00';
            return this.amount;
        },
    },
    async created() {
        this.formData.storeId = this.$route.query.storeId;
        await this.getCashierProductsFun();
        this.getPayWay();
    },
    methods: {
        changeKeyboardFun() {
            setTimeout(() => {
                this.showKeyboard = true;
            }, 100);
        },
        getPayWay() {
            if (/MicroMessenger/.test(window.navigator.userAgent)) {
                // 微信客户端
                this.formData.payWay = "wxH5";
            } else if (/AlipayClient/.test(window.navigator.userAgent)) {
                this.formData.payWay = "alipayH5";
            } else {
                this.$toast.fail("请在微信或支付宝客户端打开");
                return;
            }
        },
        async getCashierProductsFun() {
            if (!this.formData.storeId) {
                return;
            }
            try {
                const res = await getCashierProducts({
                    storeId: this.formData.storeId,
                });
                if (res.success) {
                    this.store = res.content.storeSimple
                    this.productsOptions = res.content.ownProducts?.map(item => ({
                        text: item.productName,
                        value: item.id,
                    })) ?? [];
                }
            } catch (e) {
                console.log(e)
                this.$toast("获取产品异常，请重试或联系客服");
            }
        },
        inputKey(key) {
            if (key === '.') {
                if (this.amount.includes('.')) return;
                if (!this.amount) {
                    this.amount = '0.';
                    return;
                }
            }
            if (this.amount.includes('.')) {
                const decimalPart = this.amount.split('.')[1];
                if (decimalPart && decimalPart.length >= 2) return;
            }
            this.amount += key;
        },
        deleteKey() {
            this.amount = this.amount.slice(0, -1);
        },
        async onSubmit() {
            if (!this.formData.custName || !this.formData.mobile) {
                this.$toast.fail("请输入姓名和手机号");
                return;
            }
            if (!this.amount) {
                this.$toast.fail("请输入金额");
                return;
            }
            try {
                const res = await cashierPay({
                    ...this.formData,
                    amount: this.amount,
                });
                if (res.success) {
                    const codeUrl = res.content.codeUrl;
                    if (!codeUrl) {
                        this.$toast.error("支付失败，请重试或联系客服");
                    }
                    window.location.href = codeUrl
                } else {
                    this.$toast.fail(res.msg || "支付失败");
                }
            } catch (e) {
                console.log(e)
                this.$toast.fail("支付失败，请重试或联系客服");
            }
        },
    },
};
</script>

<style scoped>
.container {
    min-height: 100vh;
    background: #f5f5f5;
    padding-bottom: 260px;
    box-sizing: border-box;
    position: relative;
}

.header {
    display: flex;
    align-items: center;
    padding: 40px 30px;
    /* background: #fff; */
}

.store-icon {
    width: 40px;
    height: 40px;
    background: #01b95a;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 12px;

}

.store-icon img {
    width: 25px;
    height: 22px;
}


.store-name {
    font-size: 18px;
    color: #333;
    font-weight: 600;
}

.form-section {
    background: #fff;
    margin: 12px;
    border-radius: 12px;
    overflow: hidden;
}

.amount-input-wrapper {
    margin: 12px;
    padding: 20px 0;
    background: #fff;
    /* border-radius: 12px; */
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ebedf0;
}

.amount-label {
    font-size: 16px;
    color: #999;
}

.amount-value {
    font-size: 24px;
    color: #333;
    font-weight: 500;
}

.keyboard-wrapper {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 0;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}

.keyboard-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(4, 55px);
    gap: 1px;
    background: #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
}

.key {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    color: #333;
    cursor: pointer;
    user-select: none;
}

.key:active {
    background: #f0f0f0;
}

.delete-key {
    background: #fff;
}

.pay-btn {
    background: #01b95a;
    color: #fff;
    font-size: 15px;
    grid-column: 4;
    grid-row: 2 / 5;
}

.pay-btn:active {
    background: #01a050;
}

.zero-key {
    grid-column: span 2;
}

.hidden {
    display: none;
}
</style>
